import { authHeader } from "../_helpers";
import request from "../_helpers/request";
import axios from "axios";
import { logExportRequestTimeoutMs } from "../constants/config";

export const LogService = {
    LogForm,
    LogFormData,
    LogFormDataWithObj,
    LogFormError,
    LogFormErrorWithObj,
    GetLogFormDataList,
    GetLogFormMeta,
    GetLogUserActionList,
    ReleaseOpLogExportLease,
};

async function LogForm(query) {
    let host = "https://e.adsale.com.hk"; //请求域名
    var langid = localStorage.getItem("currentLangId");
    var showid = 9991;
    //var url=host+ '/vreg/Content/handler/MobileCode.ashx?Handler=GetEmailCode&CellNum='+email +  '&RLang=' + langid + '&showid=' + showid;
    return axios({
        method: "post",
        url: url,
        withCredentials: false,
    })
        .then((res) => {
            return res;
        })
        .catch((err) => {
            console.error(err);
        });
}

async function LogFormData(data) {
    return await request({
        url: "Utility/LogNewBackEndForm",
        method: "post",
        data: data,
    })
        .then((res) => {
            return res;
        })
        .catch((err) => {
            console.error(err);
        });
}

async function LogFormDataWithObj(req, data) {
    try {
        const formJsonStr = JSON.stringify(data);
        const request = { ...req, FormJSON: formJsonStr };
        return await LogFormData(request);
    } catch (err) {
        console.error(err);
    }
}

// type LogFormErrorDataParams = {
//   EmpCompanyId: number,
//   ErrorLog: string,
//   EmpProductId?: number,
//   PageName?: string,
//   SectionName?: string,
//   Action?: string
// }

/**
 * Log Form Error
 * @param {LogFormErrorDataParams} data 
 * @returns 
 */
async function LogFormError(data) {
    if (!data.EmpCompanyId || isNaN(Number(data.EmpCompanyId))) {
        data.EmpCompanyId = 0;
    }

    if (data.EmpCompanyId && typeof data.EmpCompanyId === "string") {
        data.EmpCompanyId = parseInt(data.EmpCompanyId);
    }

    if (!data.EmpProductId || isNaN(Number(data.EmpProductId))) {
        data.EmpProductId = 0;
    }

    if (data.EmpProductId && typeof data.EmpProductId === "string") {
        data.EmpProductId = parseInt(data.EmpProductId);
    }

    return await request({
        url: "Utility/LogNewBackEndFormError",
        method: "post",
        data: data,
    })
        .then((res) => {
            return res;
        })
        .catch((err) => {
            console.error(err);
        });
}

async function LogFormErrorWithObj(req, data) {
    try {
        const errorLog = JSON.stringify(data);
        const request = { ...req, ErrorLog: errorLog };
        return await LogFormError(request);
    } catch (err) {
        console.error(err);
    }
}

/**
 * Query log_form_Data records (server should implement corresponding API).
 * Suggested backend endpoint: Utility/GetLogFormDataList
 *
 * @param {Object} params
 * @returns {Promise<any>} expected shape: { isSuccessful, statusCode, data: { items, total } } or similar
 */
async function GetLogFormDataList(params) {
    return await request({
        url: "Utility/GetLogFormDataList",
        method: "post",
        timeout: logExportRequestTimeoutMs,
        // 默认隐藏未知操作者（ActionByUser=0/NULL），并默认不返回大字段 FormData/ErrorLog（需要详情时再开）
        data: {
            hideUnknownOperator: true,
            includeFormData: false,
            includeUserActionContext: false,
            ...(params || {})
        },
    })
        .then((res) => res)
        .catch((err) => {
            return {
                isSuccessful: false,
                statusCode: err?.response?.status || 500,
                data: null,
                msg: [err?.message || "GetLogFormDataList failed"],
                systemErrorMsg: [],
            };
        });
}

async function GetLogFormMeta(params) {
    return await request({
        url: "Utility/GetLogFormMeta",
        method: "post",
        data: params || {},
    })
        .then((res) => res)
        .catch((err) => {
            return {
                isSuccessful: false,
                statusCode: err?.response?.status || 500,
                data: null,
                msg: [err?.message || "GetLogFormMeta failed"],
                systemErrorMsg: [],
            };
        });
}

async function GetLogUserActionList(params) {
    return await request({
        url: "Utility/GetLogUserActionList",
        method: "post",
        timeout: logExportRequestTimeoutMs,
        // 默认隐藏未知操作者（UserId=0/NULL），并默认不返回 Url/IP/Agent 等上下文字段（需要详情时再开）
        data: {
            hideUnknownOperator: true,
            includeFormData: false,
            includeUserActionContext: false,
            ...(params || {})
        },
    })
        .then((res) => res)
        .catch((err) => {
            return {
                isSuccessful: false,
                statusCode: err?.response?.status || 500,
                data: null,
                msg: [err?.message || "GetLogUserActionList failed"],
                systemErrorMsg: [],
            };
        });
}

/** 导出任务结束（成功/失败/中止）时释放后端 Redis 租约，允许同一账号再次导出 */
async function ReleaseOpLogExportLease(params) {
    return await request({
        url: "Utility/ReleaseOpLogExportLease",
        method: "post",
        data: params || {},
        timeout: 30000,
    })
        .then((res) => res)
        .catch((err) => {
            return {
                isSuccessful: false,
                statusCode: err?.response?.status || 500,
                data: null,
                msg: [err?.message || "ReleaseOpLogExportLease failed"],
                systemErrorMsg: [],
            };
        });
}
